module.exports = {
  config: {
    apiBaseUrl: `${process.env.VUE_APP_API_URL}api/`,
    locale: '/',
    language: 'spanish',
  },
};
